import {
  BaseInput,
  BaseInputSchema,
  FileInput,
  InputType,
  SelectInput,
  SelectOption
} from '@innovactions/frontend-library';
import {DocumentLevel} from "../../enum/document-level";

export class DocumentSchema extends BaseInputSchema<any> {

  override getStylingType() {
    return null;
  }

  protected override getOrderedInputKeys(): string[] {
    return [
      'name',
      'level',
      'achievementDate',
      'validityDuration',
      'expirationDate',
      'documentFile',
    ];
  }

  protected override getEnumValue(value: any) {
    return value;
  }

  override getWrapperStyling(): string {
    return "";
  }

  override getDefaultInputs(): BaseInput[] {
    return [
      new BaseInput('name', "Naam", InputType.TEXT, undefined, true, false, [], undefined, undefined),
      new SelectInput('level', "Niveau", undefined, true, false, [], undefined, undefined, [
        new SelectOption(1, 'N.v.t.', DocumentLevel.NA, false),
        new SelectOption(2, 'MBO 1', DocumentLevel.MBO1, false),
        new SelectOption(3, 'MBO 2', DocumentLevel.MBO2, false),
        new SelectOption(4, 'MBO 3', DocumentLevel.MBO3, false),
        new SelectOption(5, 'MBO 4', DocumentLevel.MBO4, false),
        new SelectOption(6, 'HBO', DocumentLevel.HBO, false),
        new SelectOption(7, 'WO', DocumentLevel.WO, false),
        ],true),
      new BaseInput('achievementDate', "Datum van behalen", InputType.DATE, undefined, false, false, [], undefined, undefined),
      new BaseInput('validityDuration', "Geldigheidsduur", InputType.TEXT, undefined, false, false, [], undefined, undefined),
      new BaseInput('expirationDate', "Verval datum", InputType.DATE, undefined, true, false, [], undefined, undefined),
      new FileInput('documentFile', "Bestand", undefined, true, false, [], undefined, undefined, false, false, [], [], [".pdf"])
    ];
  }
}
